module.exports = new __parcel__URL__("jira-laptop-done.ad39bf9b.svg").toString();